/*rutas del layout y dashboard*/
function children (path, folder, view, name) {
  //debugger;
  return {
    name: name || view,
    path,
    component: (resolve) => import(
      `@/${folder}/${view}.vue`
    ).then(resolve)
  }
}
//import dash from './paths_dimenu_dash.js' 
import orders from './paths_dimenu_orders.js' 
import specials from './paths_dimenu_specials.js' 
import menu from './paths_dimenu_menu.js' 
import report from './paths_dimenu_report.js' 
import marketing from './paths_dimenu_marketing.js' 
import setup from './paths_dimenu_setup.js'
import restaurantinfo from './paths_dimenu_restaurant_info.js'
import menugroup from './paths_dimenu_group.js' 
import menurestore from './paths_dimenu_restore.js'
import menetatags from './paths_dimenu_metatags.js'
import reserve from './paths_dimenu_reserve_table.js'  
import fontFamily from './paths_dimenu_family.js'  
//let rutas_dash=dash.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_orders=orders.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_specials=specials.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_menu=menu.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_report=report.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_marketing=marketing.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_setup=setup.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_restaurantinfo=restaurantinfo.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_menugroup=menugroup.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_menurestore=menurestore.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_menetatags=menetatags.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_reserve=reserve.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_fontFamily=fontFamily.map(r => children(r.path, r.folder, r.view, r.name));
let rutas_children= [];
//rutas_children=rutas_children.concat(rutas_dash);
rutas_children=rutas_children.concat(rutas_orders);
rutas_children=rutas_children.concat(rutas_specials);
rutas_children=rutas_children.concat(rutas_menu);
rutas_children=rutas_children.concat(rutas_report);
rutas_children=rutas_children.concat(rutas_marketing);
rutas_children=rutas_children.concat(rutas_setup);
rutas_children=rutas_children.concat(rutas_restaurantinfo);
rutas_children=rutas_children.concat(rutas_menugroup);
rutas_children=rutas_children.concat(rutas_menurestore);
rutas_children=rutas_children.concat(rutas_menetatags);
rutas_children=rutas_children.concat(rutas_reserve);
rutas_children=rutas_children.concat(rutas_fontFamily);
export default [
  {
    path: '/dimenu',
    view: 'DimenuLayout',
    folder: 'Layouts/dimenu',
    meta: {requiresAuth: true},
    children: rutas_children
  }
];